<div class="fixed bottom-4 right-4 z-50 flex flex-col space-y-4 max-w-[90vw]">
    <div *ngFor="let toast of listOfToasts"
        class="alert shadow-lg transition-all duration-300 ease-in-out transform border-[1px]" [ngClass]="[
        toast.type === 'success' ? 'bg-success-100 border-success-400 text-success-800' : '',
        toast.type === 'error' ? 'bg-error-100 border-error-400 text-error-800' : '',
        toast.type === 'warning' ? 'bg-warning-100 border-warning-400 text-warning-800' : ''
      ]">
        <div class="flex flex-wrap gap-2 mobile:text-sm">
            <svg *ngIf="toast.type === 'success'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                viewBox="0 0 20 20" fill="none">
                <path
                    d="M18.3334 9.23355V10.0002C18.3324 11.7972 17.7505 13.5458 16.6745 14.9851C15.5986 16.4244 14.0862 17.4773 12.3629 17.9868C10.6396 18.4963 8.7978 18.4351 7.11214 17.8124C5.42648 17.1896 3.98729 16.0386 3.00922 14.5311C2.03114 13.0236 1.56657 11.2403 1.68481 9.44714C1.80305 7.65402 2.49775 5.94715 3.66531 4.58111C4.83288 3.21506 6.41074 2.26303 8.16357 1.867C9.91641 1.47097 11.7503 1.65216 13.3918 2.38355"
                    stroke="#166534" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M18.3333 3.33398L10 11.6757L7.5 9.17565" stroke="#166534" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <svg *ngIf="toast.type === 'error'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="#DC2626" stroke-width="2" fill="none" />
                <line x1="15" y1="9" x2="9" y2="15" stroke="#DC2626" stroke-width="2" stroke-linecap="round" />
                <line x1="9" y1="9" x2="15" y2="15" stroke="#DC2626" stroke-width="2" stroke-linecap="round" />
            </svg>
            <svg *ngIf="toast.type === 'warning'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                viewBox="0 0 24 24" fill="none">
                <path d="M12 2L2 22h20L12 2z" stroke="#FBBF24" stroke-width="2" stroke-linejoin="round" fill="none" />
                <line x1="12" y1="8" x2="12" y2="13" stroke="#FBBF24" stroke-width="2" stroke-linecap="round" />
                <circle cx="12" cy="17" r="1" fill="#FBBF24" />
            </svg>
            <div *ngIf="toast.autoTranslate">
                <strong class="font-bold">{{ toast.title | transloco }}</strong>
                <p class="whitespace-pre-line">{{ toast.message | transloco }}</p>
            </div>
            <div *ngIf="!toast.autoTranslate">
                <strong class="font-bold">{{ toast.title }}</strong>
                <p class="whitespace-pre-line">{{ toast.message }}</p>
            </div>
        </div>
    </div>
</div>